const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/aftersales/list'], resolve)
}

export default list
